import { TypeRegister } from './type-register';

export const typeRegisterAllowedDetail = [
  TypeRegister.RegistryChanges,
  TypeRegister.DifferentCommunication,
  TypeRegister.PopularJudges,
  TypeRegister.Electoral,
  TypeRegister.Immigration,
  TypeRegister.Emigration,
  TypeRegister.UntraceableCensus,
  TypeRegister.CriminalRecord,
  TypeRegister.AuthorizationToVoteOutsideTheMun,
  TypeRegister.AuthorizationToVotePlacesOfCare,
  TypeRegister.AddressChange,
  TypeRegister.RenewalResidence,
  TypeRegister.SpinOffAggregation,
];
